export const dhConfigCalendarSun = {
  "data": {
    "Type":"JSON",
    "url": "%expo_calendar_url%/SUN/time",
    "post_data": '{"valid_time": "%valid_time%","elements":["rise_time", "set_time"],"points": %points%,"time_diff": %time_diff%}',
    "retain":true,
    "cache":true,
  }
}